import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    standalone: true,
    selector: 'input[autofocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
  }
}